export const groupBy = <T>(array: T[], predicate: (value: T, index: number, array: T[]) => string | number) =>
  array.reduce<Record<string | number, T[]>>((acc, value, index, arr) => {
    const key = predicate(value, index, arr);
    acc[key] ||= [];
    acc[key].push(value);
    return acc;
  }, {});
